import { createElement, isValidElement, ReactElement, ReactNode } from "react";

import { LucideIcon } from "lucide-react";
import { Link } from "react-router";

import { cn } from "@/lib/utils";

interface SideMenuItemProps {
  icon: LucideIcon | ReactElement;
  label: ReactNode;
  active?: boolean;
  link?: string;
}

export function SideMenuItem({
  icon,
  label,
  active = false,
  link,
}: SideMenuItemProps) {
  const renderIcon = () => {
    // If it's already a valid React element (like <CoachingSvg />), render it as-is
    if (isValidElement(icon)) {
      return icon;
    }

    // If it's a component (like Home from lucide-react), create an element with props
    return createElement(icon as LucideIcon, { size: 15 });
  };

  const content = (
    <div
      className={cn(
        "flex items-center gap-3 px-3 py-2.5 my-1 text-[15px] font-semibold rounded transition-all duration-200 ease-in-out",
        "text-gray-600 hover:text-blue-600 hover:bg-slate-50",
        "[&>svg]:text-gray-400 hover:[&>svg]:text-blue-600",
        active && [
          "text-blue-600 bg-slate-50 font-bold",
          "[&>svg]:text-blue-600",
        ],
      )}
    >
      {renderIcon()}
      <span>{label}</span>
    </div>
  );

  if (link) {
    return <Link to={link}>{content}</Link>;
  }

  return content;
}
